/*
 * @Description: 删除弹窗
 * @Author: ywj
 * @Date: 2025-03-06 16:48:55
 * @LastEditTime: 2025-03-12 10:02:15
 * @LastEditors: Please set LastEditors
 */
import React from "react";
import UModal from '@/components/modal'

interface IProps { 
  showDeleteModal: boolean,
  setShowDeleteModal: (showDeleteModal: boolean) => void,
  handleDelete: () => void,
  title: string,
  content: string,
  okText?: string,
  cancelText?: string,
}

const DeleteModal: React.FC<IProps> = (props) => {
  const {
    showDeleteModal,
    setShowDeleteModal,
    handleDelete,
    title,
    content,
    okText='确定',
    cancelText='取消',
  } = props;
  const handleCancel = () => {
    setShowDeleteModal(false)
  }
  const handleOk = () => {
    handleDelete();
  }
  return <UModal
  centered
  width={450}
  title={title}
  open={showDeleteModal}
  // initialValues={editModalState}
    cancelText={ cancelText}
  okText={okText}
  onCancel={handleCancel}
  onOk={handleOk}
  className="invoice-add-modal"
  >
    <div style={{ padding: '50px 0', textAlign: 'center' }}>{ content}</div>
    </UModal>
}

export default DeleteModal;
